import { makeMutationHook, makeQueryHook } from "utils/apolloUtils";

import { GET_ORGANIZATION, GET_ORGANIZATIONS } from "./queries";
import {
  GetOrganizations,
  GetOrganizationsVariables,
  GetOrganization,
  GetOrganizationVariables,
} from "./__generated__/queries";
import {
  CREATE_ORGANIZATION,
  DELETE_ORGANIZATION,
  UPDATE_ORGANIZATION,
} from "./mutations";
import {
  CreateOrganization,
  CreateOrganizationVariables,
  UpdateOrganization,
  UpdateOrganizationVariables,
  DeleteOrganization,
  DeleteOrganizationVariables,
} from "./__generated__/mutations";

export const useOrganizationListQuery = makeQueryHook<
  GetOrganizations,
  GetOrganizationsVariables
>(GET_ORGANIZATIONS);

export const useOrganizationDetailsQuery = makeQueryHook<
  GetOrganization,
  GetOrganizationVariables
>(GET_ORGANIZATION);

export const useOrganizationCreate = makeMutationHook<
  CreateOrganization,
  CreateOrganizationVariables
>(CREATE_ORGANIZATION);

export const useOrganizationUpdateMutation = makeMutationHook<
  UpdateOrganization,
  UpdateOrganizationVariables
>(UPDATE_ORGANIZATION);

export const useOrganizationDeleteMutation = makeMutationHook<
  DeleteOrganization,
  DeleteOrganizationVariables
>(DELETE_ORGANIZATION);
